// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; import './autoload/lazyload.js'; // eslint-disable-line

// Import local dependencies
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import './pagination';
// import { jarallax, jarallaxElement } from 'jarallax';
import './ajax';
import ScrollOut from 'scroll-out';
//import Masonry from 'masonry-layout';

/**
 * Init foundation
 */
$(document).foundation();

import './global';
import './sticky-header';

let scrollOut;
//let msnry;
//let masonryState = false;

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function() {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function() {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

function setVisibility2Top() {
  // hide return to top button when at top
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  if (scrollTop < 500) jQuery('#anchor-top').fadeOut('slow');
  else jQuery('#anchor-top').fadeIn('slow');
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function() {
  // Scroll to section in another page
  selectNews();
  function scrollToSection(id) {
    var margin = -245;
    $('html, body').animate(
      {
        scrollTop: $(id).offset().top + margin + 'px',
      },
      1000
    );
  }
  if (window.location.hash == '#service-label') {
    //console.log(this.pathname);
    $(window.location.hash).trigger('click');
    scrollToSection(window.location.hash);
  }
  $('.service-location a').on('click', function(e) {
    e.preventDefault();

    if (this.pathname === window.location.pathname) {
      $(this.hash).trigger('click');
      scrollToSection(this.hash);
    } else {
      // Otherwise, redirect them to the page
      window.location.replace(this.href);
    }
  });

  // if ($(window).width() < 640) {
  //   masonryInit();
  // }

  /**
   * Application template tabs
   */
  let termLink = $('#applicationsTabs').data('term');
  $('#applicationsTabs li').each(function() {
    let currTerm = $(this).data('slug');
    if (termLink && termLink == currTerm) {
      $(this)
        .find('a')
        .trigger('click');
    }
  });

  /**
   * Product category gallery and slider
   */
  $('.product-cat-current__media .slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    fade: true,
    rows: 0,
    asNavFor: '.product-cat-current__media .slider-nav',
  });
  $('.product-cat-current__media .slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: false,
    asNavFor: '.product-cat-current__media .slider-for',
    dots: false,
    arrows: false,
    rows: 0,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $('.product-cat-current__brands-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    rows: 0,
  });

  $('.product-cat-products__list').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: $('.slider-prev'),
    nextArrow: $('.slider-next'),
    dots: false,
    rows: 0,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(
    '.home-posts-wrapper__slider, body .home-posts-wrapper__slider--refresh'
  ).slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    dots: true,
    rows: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '110px',
          infinite: false,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0px',
          adaptiveHeight: true,
        },
      },
    ],
  });
  $('.home-posts-wrapper__tabs').on('click', function() {
    let currSlide = $('body .home-posts-wrapper__slider--refresh');
    //
    if (currSlide.length) {
      currSlide.slick('unslick');
    }
  });

  /**
   * Dropdown mobile menu item if no link page
   */
  $('.js-item-dropdown > a').on('click', function(e) {
    e.preventDefault();
    if (
      $(this)
        .parent()
        .hasClass('has-dropdown')
    ) {
      $(this)
        .siblings()
        .click();
    }
  });

  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  scrollOut = ScrollOut({
    treshold: 0,
    once: true,
    onShown: function(element) {
      if ($(element).is('.ease-order')) {
        $(element)
          .find('.ease-order__item')
          .each(function(i) {
            let $this = $(this);
            $(this).attr('data-scroll', '');
            window.setTimeout(function() {
              $this.attr('data-scroll', 'in');
            }, 300 * i);
          });
      }
    },
  });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function(event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function() {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  var scrollFixed;
  $(window)
    .on('toggled.zf.responsiveToggle', function() {
      $('.menu-icon').toggleClass('is-active');

      setTimeout(function() {
        if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 1200) {
          scrollFixed = $(window).scrollTop();
          $('.body__inner').addClass('is-active');
        } else {
          $('.body__inner').removeClass('is-active');
          $(window).scrollTop(scrollFixed);
        }
      }, 100);
    })
    .on('changed.zf.mediaquery', function() {
      $('.body__inner').removeClass('is-active');
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function() {
    setTimeout(function() {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  resizeVideo();

  /* set visibility of scroll-to-top button */
  setVisibility2Top();
  $(window).on('scroll', function() {
    setVisibility2Top();
  });
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function() {
  // jQuery code goes here
  //scrollOut.update(); // removed to prevent JS crash and content not to render
  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  $('.tabs-title a').on('click', function() {
    setTimeout(function() {
      scrollOut.update();
    }, 10);
  });
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function() {
  // jQuery code goes here
  // if ($(window).width() < 640) {
  //   if (masonryState == false) {
  //     masonryInit();
  //   }
  // } else {
  //   if (masonryState == true) {
  //     masonryDestroy();
  //   }
  // }
  resizeVideo();
  selectNews();
});

function selectNews() {
  if ($('#corporate_news-label').length) {
    if ($(window).outerWidth() < 1024) {
      $('#corporate_news-label').click();
    }
  }
}

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function() {
  // jQuery code as needed
});

// function masonryInit() {
//   msnry = new Masonry('.footer-menu__wrapper', {
//     percentPosition: true,
//     itemSelector: '.footer-menu',
//     columnWidth: '.grid-sizer',
//   });
//
//   masonryState = true;
// }
//
// function masonryDestroy() {
//   msnry.destroy();
//   masonryState = false;
// }
